@if (people && people.length > 0) {
  <div class="contributors">
    <h3>Contributors</h3>
    @for (person of people; track person) {
      @if (person.fullname && person.fullname.length > 0) {
        <div
          class="contributor"
          routerLink="/directory/{{ person.id }}"
          >
          <h4>{{ person.fullname }}</h4>
          <h5>{{ person.jobTitle }}</h5>
        </div>
      }
    }
  </div>
}
